module.exports = "https://www.niulinkcloud.com/_next/static/media/icon2.429b87ae1e466c9ac3a732f0e2e36905.png";